/**
 * ÉKEZET- ÉS KISBETŰ-HAJTOGATÁS a kereséshez.
 *
 * Magyar felületen ez nem finomság, hanem a használhatóság feltétele: a
 * „Hiánylista" megtalálásához a könyvelő „hianylista"-t gépel, az „Alföldi"-hez
 * „alfoldi"-t — ékezet nélkül, mert gyorsabb. Az `NFD` bontás után a
 * kombináló jeleket dobjuk el; így az „ő" és az „o" ugyanaz a keresésben, a
 * MEGJELENÍTÉS viszont érintetlen marad.
 *
 * MIÉRT KÖZÖS, MÁR A MÁSODIK HASZNÁLATNÁL. A `CLAUDE.md` háromszabályos
 * refaktorja szerint a második előfordulásnál még csak TODO járna. Ez viszont
 * nem absztrakció, hanem egy háromsoros függvény EGYETLEN jelentéssel — és a
 * kétszer megírt változat pont abban csúszna el, ami miatt van: az egyik
 * helyen bekerülne egy karakterosztály, a másikon nem, és a két kereső
 * másképp találna. A szabály a korai ÁLTALÁNOSÍTÁS ellen szól, nem a
 * másolás mellett.
 */
export function fold(value: string): string {
  return value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
}

/**
 * SZAVANKÉNT SZŰKÍT, nem egyetlen részláncra.
 *
 * A „alf epito" így megtalálja az „Alföldi Építőanyag Kereskedelmi Kft."-t,
 * pedig összefüggő részláncként nem szerepel benne. Aki keres, töredékeket
 * gépel — egy szigorú `includes` arra tanítana, hogy pontosan írja le, amit
 * amúgy is lát a képernyőn.
 *
 * ÜRES KERESÉS = MINDEN. Nem „semmi": a szűrő kikapcsolt állapota nem
 * ugyanaz, mint a nulla találat.
 */
export function matchesQuery(haystack: string, query: string): boolean {
  const words = fold(query).split(/\s+/).filter(Boolean);
  if (words.length === 0) {
    return true;
  }

  const folded = fold(haystack);
  return words.every((word) => folded.includes(word));
}
